import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_PatientConsentForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_PatientConsentForm' className='file-pdf-document'>
            <div className='file-template'>


                <h3>HIV PATIENT CONSENT FORM
                </h3>
                <h4>Informed Consent to Perform HIV Testing
                </h4>
                <p>
                    My health care provider has answered any questions I have about HIV/AIDS. I have been provided information with the following details about HIV testing:
                </p>
                <ul>
                    <li>HIV is the virus that causes AIDS and can be transmitted through unprotected sex (vaginal, anal, or oral sex) with someone who has HIV; contact with blood as in sharing needles (piercing, tattooing, drug equipment including needles), by HIV-infected pregnant women to their infants during pregnancy or delivery, or while breast feeding.
                    </li>
                    <li>There are treatments for HIV/AIDS that can help an individual stay healthy.
                    </li>
                    <li>Individuals with HIV/AIDS can adopt safe practices to protect uninfected and infected people in their lives from becoming infected or being infected themselves with different strains of HIV.
                    </li>
                    <li>Testing is voluntary and can be done anonymously at a public testing center.
                    </li>
                    <li>The law protects the confidentiality of HIV test results and other related information.
                    </li>
                    <li>The law prohibits discrimination based on an individual's HIV status and services are available to help with such consequences.
                    </li>
                    <li>The law allows an individual's informed consent for HIV related testing to be valid for such testing until such consent is revoked by the subject of the HIV test or expires by its terms.
                    </li>
                </ul>
                <p>
                    I agree to be tested for HIV infection. If the results show I have HIV, I agree to additional testing which may occur on the sample I provide today to determine the best treatment for me and to help guide HIV prevention programs. I also agree to future tests to guide my treatment. I understand that I can withdraw my consent for future tests at any time. If I test positive for HIV infection, I understand that my health care provider will talk with me about telling my sex or needle-sharing partners of possible exposure.
                </p>
                <p>
                    I may revoke my consent orally or in writing at any time. As long as this consent is in force, my provider may conduct additional tests without asking me to sign another consent form. In those cases, my provider will tell me if other HIV tests will be performed and will note this in my medical record.
                </p>
                <p>
                    <strong>Medical Record # (if any):</strong>
                    <input type="text" id="txtMedicalRecord" name="txtMedicalRecord" className="add-only"/>
                </p>







            </div>
        </form>

    )
}